@for (data of towAndRepairShopData; track data) {
  <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
    <div class="float-left">
      <strong>{{ data.serviceRequestPartnerType }}</strong>
    </div>
    <div class="float-right">
      <div>{{ data.serviceRequestPartnerName }}</div>
      <div>
        <span>{{ data.businessAddress.addressLine1 }}</span> <br />
        <span>{{ data.businessAddress.city }}</span>
        <span>{{ data.businessAddress.state ? ', ' + data.businessAddress.state : '' }}</span>
        <span> {{ data.businessAddress.zipCode }}</span>
      </div>
      <div>
        <span>{{ data.phoneNumber | prettyPhoneNumber }}</span>
      </div>
    </div>
  </div>
}
